// internationalization
import type { TFunction } from 'i18next';

// libraries
import { z } from 'zod';

export function createAccountFormSchema(t: TFunction) {
  return z.object({
    name: z
      .string()
      .min(1, t('input.required', { ns: 'validation' }))
      .min(2, t('input.tooShort', { ns: 'validation', min: 2 }))
      .max(100, t('input.tooLong', { ns: 'validation', max: 100 })),
    address: z
      .string()
      .min(1, t('input.required', { ns: 'validation' }))
      .max(200, t('input.tooLong', { ns: 'validation', max: 200 })),
    billingAddress: z
      .string()
      .max(200, t('input.tooLong', { ns: 'validation', max: 200 })),
  });
}

export type CreateAccountFormValues = z.infer<
  ReturnType<typeof createAccountFormSchema>
>;
